module.exports = __webpack_public_path__ + "img/device04.b2dbab52.png";